import { BaseModel } from "./BaseModel";

export class WorkflowStep extends BaseModel {
  schema = "/step";
  constructor(params) {
    return super(params, "/step");
  }
}
